import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100vw;
  background: #EFEFEF;
  justify-content: flex-start;
`
export const ContainerItems = styled.div`
  padding: 20px;
  width: 100%
`
